export const DELETED_TOOTH_DETECTION_ISO_NUMBER = 404;
